/** Stable identity of each booking step, used as the key under which its URL is persisted. */
export const BOOKING_STEP = {
	SEARCH: "search",
	QUOTE: "quote",
	PAYMENT: "payment",
	CONFIRMATION: "confirmation",
} as const;

export type BookingStepKey = (typeof BOOKING_STEP)[keyof typeof BOOKING_STEP];

/** Booking tunnels: the search tunnels plus prepackage, the only one that opens with a search step. */
export type BookingTunnel = "sdp" | "stopover" | "hotelonly" | "pp";

export type BookingStepDefinition = {
	key: BookingStepKey;
	labelId: string;
	pathname: string;
};

/** Search tunnels (sdp, stopover, hotelonly) share the same 3 steps and labels; they start at the quote. */
const SEARCH_TUNNEL_STEPS: BookingStepDefinition[] = [
	{
		key: BOOKING_STEP.QUOTE,
		labelId: "booking.stepper.quote",
		pathname: "/booking/quote",
	},
	{
		key: BOOKING_STEP.PAYMENT,
		labelId: "booking.stepper.payment",
		pathname: "/booking/payment",
	},
	{
		key: BOOKING_STEP.CONFIRMATION,
		labelId: "booking.stepper.confirmation",
		pathname: "/booking/confirmation",
	},
];

/** Ordered steps per tunnel. Prepackage adds a search step before the shared 3 steps. */
export const BOOKING_STEPS_BY_TUNNEL: Record<BookingTunnel, BookingStepDefinition[]> = {
	pp: [
		{
			key: BOOKING_STEP.SEARCH,
			labelId: "booking.stepper.search",
			pathname: "/booking/search",
		},
		...SEARCH_TUNNEL_STEPS,
	],
	sdp: SEARCH_TUNNEL_STEPS,
	stopover: SEARCH_TUNNEL_STEPS,
	hotelonly: SEARCH_TUNNEL_STEPS,
};
